import { Campaign, NationalCampaign } from '@domain/campaign';
import {
  createContext,
  useState,
  useEffect,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import { useRouter } from 'next/router';
import { Event } from '@components/calendar';

export type CampaignContextType = {
  storedCampaign: NationalCampaign | Campaign | null | undefined;
  setStoredCampaign: (
    data: NationalCampaign | Campaign | null | undefined
  ) => void;
  isWithinBoundry: KeyValueType;
  setIsWithinBoundry: Dispatch<SetStateAction<KeyValueType>>;
  selectedEvent: Event | null;
  setSelectedEvent: (event: Event | null) => void;
  areaLarge: KeyValueType;
  setAreaLarge: Dispatch<SetStateAction<KeyValueType>>;
};

export type KeyValueType = {
  [key: string]: boolean;
};

export const CampaignContext = createContext<CampaignContextType>({
  storedCampaign: undefined,
  setStoredCampaign: () => {},
  isWithinBoundry: {},
  setIsWithinBoundry: () => {},
  selectedEvent: null,
  setSelectedEvent: () => {},
  areaLarge: {},
  setAreaLarge: () => {},
});

const CampaignProvider = ({ children }: { children: ReactNode }) => {
  const [storedCampaign, setStoredCampaign] = useState<
    NationalCampaign | Campaign | null | undefined
  >();
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const router = useRouter();

  // reset context state based on url
  useEffect(() => {
    if (!router.asPath.includes('/campaigns/create')) {
      setStoredCampaign(null);
    }
  }, [router]);

  const [isWithinBoundry, setIsWithinBoundry] = useState<KeyValueType>({});
  const [areaLarge, setAreaLarge] = useState<KeyValueType>({});
  return (
    <CampaignContext.Provider
      value={{
        storedCampaign,
        isWithinBoundry,
        selectedEvent,
        setSelectedEvent,
        setStoredCampaign,
        areaLarge,
        setIsWithinBoundry,
        setAreaLarge,
      }}>
      {children}
    </CampaignContext.Provider>
  );
};

export default CampaignProvider;
